// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var List = require("rescript/lib/js/list.js");
var $$Array = require("rescript/lib/js/array.js");
var Curry = require("rescript/lib/js/curry.js");
var React = require("react");
var Caml_obj = require("rescript/lib/js/caml_obj.js");
var Belt_List = require("rescript/lib/js/belt_List.js");
var Belt_Option = require("rescript/lib/js/belt_Option.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var JsxRuntime = require("react/jsx-runtime");
var Image$ReactHooksTemplate = require("../common/image.res.js");
var Question$ReactHooksTemplate = require("./Question.res.js");
var ThankYou$ReactHooksTemplate = require("./ThankYou.res.js");
var DataField$ReactHooksTemplate = require("../data_fields/dataField.res.js");
var OptionGroup$ReactHooksTemplate = require("../common/optionGroup.res.js");
var RedirectionUrl$ReactHooksTemplate = require("./redirectionUrl.res.js");
var TicketCategory$ReactHooksTemplate = require("../tickets/ticketCategory.res.js");

function FilteredSelectBox(props) {
  var __multipleSelect = props.multipleSelect;
  var selectedOption = props.selectedOption;
  var __className = props.className;
  var onChange = props.onChange;
  var __placeholder = props.placeholder;
  var placeholder = __placeholder !== undefined ? __placeholder : "";
  var className = __className !== undefined ? __className : "";
  var multipleSelect = __multipleSelect !== undefined ? __multipleSelect : false;
  var match = React.useState(function (param) {
        return {
                open_: false
              };
      });
  var setState = match[1];
  var state = match[0];
  var domElement = React.useRef(null);
  var handleOutsideClick = function ($$event) {
    var targetElement = $$event.target;
    var selectBoxElement = Belt_Option.getExn(Caml_option.nullable_to_opt(domElement.current));
    if (!selectBoxElement.contains(targetElement)) {
      return Curry._1(setState, (function (param) {
                    return {
                            open_: false
                          };
                  }));
    }
    
  };
  React.useEffect((function (param) {
          document.addEventListener("mousedown", handleOutsideClick);
          return (function (param) {
                    document.removeEventListener("mousedown", handleOutsideClick);
                  });
        }), []);
  var handleClick = function ($$event) {
    $$event.preventDefault();
    $$event.stopPropagation();
    Curry._1(setState, (function (state) {
            return {
                    open_: !state.open_
                  };
          }));
  };
  var removeQuestion = function (selectedItem, optionList) {
    if (selectedOption.TAG === "Questions") {
      return List.filter(function (param) {
                    var a = param[0]._0;
                    return List.exists((function (param) {
                                  return !Caml_obj.equal(Question$ReactHooksTemplate.uuid(param[0]._0), Question$ReactHooksTemplate.uuid(a));
                                }), optionList);
                  })(selectedItem);
    } else {
      return /* [] */0;
    }
  };
  var removeThankyou = function (selectedItem, optionList) {
    if (selectedOption.TAG === "ThankYous") {
      return List.filter(function (param) {
                    var t = param[0];
                    return List.exists((function (param) {
                                  return !Caml_obj.equal(ThankYou$ReactHooksTemplate.uuid(param[0]), ThankYou$ReactHooksTemplate.uuid(t));
                                }), optionList);
                  })(selectedItem);
    } else {
      return /* [] */0;
    }
  };
  var removeDataField = function (selectedItem, optionList) {
    if (selectedOption.TAG === "DataFields") {
      return List.filter(function (param) {
                    var t = param[0];
                    return List.exists((function (param) {
                                  return !Caml_obj.equal(DataField$ReactHooksTemplate.id(param[0]), DataField$ReactHooksTemplate.id(t));
                                }), optionList);
                  })(selectedItem);
    } else {
      return /* [] */0;
    }
  };
  var handleOptionClick = function (optionItem, selected) {
    var updatedSelectedOptions;
    switch (optionItem.TAG) {
      case "Questions" :
          var xs = optionItem._0;
          var newList;
          if (selectedOption.TAG === "Questions") {
            var selectedQuestions = selectedOption._0;
            newList = selected ? removeQuestion(selectedQuestions, xs) : Belt_List.concat(xs, selectedQuestions);
          } else {
            newList = xs;
          }
          updatedSelectedOptions = multipleSelect ? ({
                TAG: "Questions",
                _0: newList
              }) : (
              Caml_obj.equal(selectedOption, {
                    TAG: "Questions",
                    _0: xs
                  }) ? ({
                    TAG: "Questions",
                    _0: /* [] */0
                  }) : ({
                    TAG: "Questions",
                    _0: xs
                  })
            );
          break;
      case "ThankYous" :
          var xs$1 = optionItem._0;
          var newList$1;
          if (selectedOption.TAG === "ThankYous") {
            var selectedThankyous = selectedOption._0;
            newList$1 = selected ? removeThankyou(selectedThankyous, xs$1) : Belt_List.concat(xs$1, selectedThankyous);
          } else {
            newList$1 = xs$1;
          }
          updatedSelectedOptions = multipleSelect ? ({
                TAG: "ThankYous",
                _0: newList$1
              }) : (
              Caml_obj.equal(selectedOption, {
                    TAG: "ThankYous",
                    _0: xs$1
                  }) ? ({
                    TAG: "ThankYous",
                    _0: /* [] */0
                  }) : ({
                    TAG: "ThankYous",
                    _0: xs$1
                  })
            );
          break;
      case "DataFields" :
          var xs$2 = optionItem._0;
          var newList$2;
          if (selectedOption.TAG === "DataFields") {
            var selectedDataFields = selectedOption._0;
            newList$2 = selected ? removeDataField(selectedDataFields, xs$2) : Belt_List.concat(xs$2, selectedDataFields);
          } else {
            newList$2 = xs$2;
          }
          updatedSelectedOptions = multipleSelect ? ({
                TAG: "DataFields",
                _0: newList$2
              }) : (
              Caml_obj.equal(selectedOption, {
                    TAG: "DataFields",
                    _0: xs$2
                  }) ? ({
                    TAG: "DataFields",
                    _0: /* [] */0
                  }) : ({
                    TAG: "DataFields",
                    _0: xs$2
                  })
            );
          break;
      case "RedirectionUrls" :
          var xs$3 = optionItem._0;
          updatedSelectedOptions = Caml_obj.equal(selectedOption, {
                TAG: "RedirectionUrls",
                _0: xs$3
              }) ? ({
                TAG: "RedirectionUrls",
                _0: /* [] */0
              }) : ({
                TAG: "RedirectionUrls",
                _0: xs$3
              });
          break;
      case "TicketCategories" :
          var xs$4 = optionItem._0;
          updatedSelectedOptions = Caml_obj.equal(selectedOption, {
                TAG: "TicketCategories",
                _0: xs$4
              }) ? ({
                TAG: "TicketCategories",
                _0: /* [] */0
              }) : ({
                TAG: "TicketCategories",
                _0: xs$4
              });
          break;
      
    }
    Curry._1(setState, (function (state) {
            return {
                    open_: !state.open_
                  };
          }));
    Curry._1(onChange, updatedSelectedOptions);
  };
  var renderOptionLabel = function (option) {
    return JsxRuntime.jsx("div", {
                children: OptionGroup$ReactHooksTemplate.optionLabel(option)
              });
  };
  var renderPlaceholder = function (placeholder) {
    return JsxRuntime.jsx("div", {
                children: JsxRuntime.jsx("p", {
                      children: placeholder,
                      className: "flex items-center"
                    }),
                className: "flex w-11/12 p-2"
              });
  };
  var placeholderText;
  var exit = 0;
  switch (selectedOption.TAG) {
    case "Questions" :
        var xs = selectedOption._0;
        if (multipleSelect) {
          placeholderText = xs ? JsxRuntime.jsx("div", {
                  children: $$Array.of_list(List.map((function (x) {
                              return JsxRuntime.jsxs("div", {
                                          children: [
                                            renderOptionLabel(x),
                                            JsxRuntime.jsx("div", {
                                                  children: JsxRuntime.jsx("img", {
                                                        className: "h-6-px",
                                                        src: Image$ReactHooksTemplate.closeIcon
                                                      }),
                                                  className: "flex items-center cursor-default justify-end",
                                                  onClick: (function (param) {
                                                      handleOptionClick({
                                                            TAG: "Questions",
                                                            _0: {
                                                              hd: x,
                                                              tl: /* [] */0
                                                            }
                                                          }, true);
                                                    })
                                                })
                                          ],
                                          className: "flex gap-2 border border-gray-400 rounded truncate px-2 py-1"
                                        });
                            }), xs)),
                  className: "flex flex-wrap w-11/12 text-xs gap-1"
                }) : renderPlaceholder(placeholder);
        } else {
          var x = Belt_List.head(xs);
          placeholderText = x !== undefined ? renderOptionLabel(x) : renderPlaceholder(placeholder);
        }
        break;
    case "ThankYous" :
        var xs$1 = selectedOption._0;
        if (multipleSelect) {
          placeholderText = xs$1 ? JsxRuntime.jsx("div", {
                  children: $$Array.of_list(List.map((function (x) {
                              return JsxRuntime.jsxs("div", {
                                          children: [
                                            renderOptionLabel(x),
                                            JsxRuntime.jsx("div", {
                                                  children: JsxRuntime.jsx("img", {
                                                        className: "h-6-px",
                                                        src: Image$ReactHooksTemplate.closeIcon
                                                      }),
                                                  className: "flex items-center cursor-default justify-end",
                                                  onClick: (function (param) {
                                                      handleOptionClick({
                                                            TAG: "ThankYous",
                                                            _0: {
                                                              hd: x,
                                                              tl: /* [] */0
                                                            }
                                                          }, true);
                                                    })
                                                })
                                          ],
                                          className: "flex border border-gray-400 rounded truncate"
                                        });
                            }), xs$1)),
                  className: "flex flex-wrap w-11/12 text-xs"
                }) : renderPlaceholder(placeholder);
        } else {
          var x$1 = Belt_List.head(xs$1);
          placeholderText = x$1 !== undefined ? renderOptionLabel(x$1) : renderPlaceholder(placeholder);
        }
        break;
    case "DataFields" :
        var xs$2 = selectedOption._0;
        if (multipleSelect) {
          placeholderText = xs$2 ? JsxRuntime.jsx("div", {
                  children: $$Array.of_list(List.map((function (x) {
                              return JsxRuntime.jsxs("div", {
                                          children: [
                                            renderOptionLabel(x),
                                            JsxRuntime.jsx("div", {
                                                  children: JsxRuntime.jsx("img", {
                                                        className: "h-6-px",
                                                        src: Image$ReactHooksTemplate.closeIcon
                                                      }),
                                                  className: "flex items-center cursor-default justify-end",
                                                  onClick: (function (param) {
                                                      handleOptionClick({
                                                            TAG: "DataFields",
                                                            _0: {
                                                              hd: x,
                                                              tl: /* [] */0
                                                            }
                                                          }, true);
                                                    })
                                                })
                                          ],
                                          className: "flex border border-gray-400 rounded truncate"
                                        });
                            }), xs$2)),
                  className: "flex flex-wrap w-11/12 text-xs"
                }) : renderPlaceholder(placeholder);
        } else {
          var x$2 = Belt_List.head(xs$2);
          placeholderText = x$2 !== undefined ? renderOptionLabel(x$2) : renderPlaceholder(placeholder);
        }
        break;
    case "RedirectionUrls" :
    case "TicketCategories" :
        exit = 1;
        break;
    
  }
  if (exit === 1) {
    var x$3 = Belt_List.head(selectedOption._0);
    placeholderText = x$3 !== undefined ? renderOptionLabel(x$3) : renderPlaceholder(placeholder);
  }
  var listBoxCSS = state.open_ ? "block" : "hidden";
  return JsxRuntime.jsxs("div", {
              children: [
                JsxRuntime.jsxs("div", {
                      children: [
                        JsxRuntime.jsx("div", {
                              children: placeholderText,
                              className: "flex items-center truncate"
                            }),
                        JsxRuntime.jsx("div", {
                              children: state.open_ ? JsxRuntime.jsx("img", {
                                      className: "h-7-px w-7-px",
                                      src: Image$ReactHooksTemplate.chevronUp
                                    }) : JsxRuntime.jsx("img", {
                                      className: "h-7-px w-7-px",
                                      src: Image$ReactHooksTemplate.chevronDown
                                    }),
                              className: "flex items-center justify-end cursor-pointer flex-shrink-0"
                            })
                      ],
                      className: "border cursor-pointer rounded flex justify-between " + className,
                      onClick: handleClick
                    }),
                JsxRuntime.jsx("div", {
                      children: $$Array.of_list(List.map((function (option) {
                                  switch (option.TAG) {
                                    case "Questions" :
                                        return JsxRuntime.jsx("div", {
                                                    children: JsxRuntime.jsxs(JsxRuntime.Fragment, {
                                                          children: [
                                                            JsxRuntime.jsx("div", {
                                                                  children: OptionGroup$ReactHooksTemplate.groupName(option),
                                                                  className: "text-base font-medium text-darkcharcoal m-2 p-1"
                                                                }),
                                                            $$Array.of_list(List.map((function (param) {
                                                                        var label = param[1];
                                                                        var x = param[0];
                                                                        var match;
                                                                        match = x.TAG === "Question" ? [
                                                                            x._0,
                                                                            undefined
                                                                          ] : [
                                                                            x._0,
                                                                            x._1
                                                                          ];
                                                                        var uuid = match[1];
                                                                        var question = match[0];
                                                                        var selected;
                                                                        selected = selectedOption.TAG === "Questions" ? List.exists((function (param) {
                                                                                  var q = param[0];
                                                                                  if (q.TAG === "Question") {
                                                                                    if (uuid !== undefined) {
                                                                                      return false;
                                                                                    } else {
                                                                                      return Caml_obj.equal(Question$ReactHooksTemplate.uuid(q._0), Question$ReactHooksTemplate.uuid(question));
                                                                                    }
                                                                                  } else if (uuid !== undefined) {
                                                                                    return q._1 === uuid;
                                                                                  } else {
                                                                                    return false;
                                                                                  }
                                                                                }), selectedOption._0) : false;
                                                                        return JsxRuntime.jsx("div", {
                                                                                    children: OptionGroup$ReactHooksTemplate.optionLabel([
                                                                                          x,
                                                                                          label
                                                                                        ]),
                                                                                    className: selected ? "text-left bg-ghostwhiteblue px-2 py-1 text-sm" : "hover:bg-gray-300 text-left px-2 py-1 text-sm",
                                                                                    onClick: (function (param) {
                                                                                        handleOptionClick({
                                                                                              TAG: "Questions",
                                                                                              _0: {
                                                                                                hd: [
                                                                                                  x,
                                                                                                  label
                                                                                                ],
                                                                                                tl: /* [] */0
                                                                                              }
                                                                                            }, selected);
                                                                                      })
                                                                                  });
                                                                      }), option._0))
                                                          ]
                                                        })
                                                  });
                                    case "ThankYous" :
                                        return JsxRuntime.jsx("div", {
                                                    children: JsxRuntime.jsxs(JsxRuntime.Fragment, {
                                                          children: [
                                                            JsxRuntime.jsx("div", {
                                                                  children: OptionGroup$ReactHooksTemplate.groupName(option),
                                                                  className: "text-base font-medium text-darkcharcoal m-2 p-1"
                                                                }),
                                                            $$Array.of_list(List.map((function (param) {
                                                                        var label = param[1];
                                                                        var x = param[0];
                                                                        var selected;
                                                                        selected = selectedOption.TAG === "ThankYous" ? List.exists((function (param) {
                                                                                  return Caml_obj.equal(ThankYou$ReactHooksTemplate.uuid(param[0]), ThankYou$ReactHooksTemplate.uuid(x));
                                                                                }), selectedOption._0) : false;
                                                                        return JsxRuntime.jsx("div", {
                                                                                    children: JsxRuntime.jsx("div", {
                                                                                          children: OptionGroup$ReactHooksTemplate.optionLabel([
                                                                                                x,
                                                                                                label
                                                                                              ]),
                                                                                          className: selected ? "text-left bg-ghostwhiteblue px-2 py-1 text-sm" : "hover:bg-gray-300 text-left px-2 py-1 text-sm",
                                                                                          onClick: (function (param) {
                                                                                              handleOptionClick({
                                                                                                    TAG: "ThankYous",
                                                                                                    _0: {
                                                                                                      hd: [
                                                                                                        x,
                                                                                                        label
                                                                                                      ],
                                                                                                      tl: /* [] */0
                                                                                                    }
                                                                                                  }, selected);
                                                                                            })
                                                                                        }),
                                                                                    className: "border-b border-bottom-gray-600"
                                                                                  });
                                                                      }), option._0))
                                                          ]
                                                        })
                                                  });
                                    case "DataFields" :
                                        return JsxRuntime.jsx("div", {
                                                    children: JsxRuntime.jsxs(JsxRuntime.Fragment, {
                                                          children: [
                                                            JsxRuntime.jsx("div", {
                                                                  children: OptionGroup$ReactHooksTemplate.groupName(option),
                                                                  className: "text-base font-medium text-darkcharcoal m-2 p-1"
                                                                }),
                                                            $$Array.of_list(List.map((function (param) {
                                                                        var label = param[1];
                                                                        var x = param[0];
                                                                        var selected;
                                                                        selected = selectedOption.TAG === "DataFields" ? List.exists((function (param) {
                                                                                  return Caml_obj.equal(DataField$ReactHooksTemplate.id(param[0]), DataField$ReactHooksTemplate.id(x));
                                                                                }), selectedOption._0) : false;
                                                                        return JsxRuntime.jsx("div", {
                                                                                    children: JsxRuntime.jsx("div", {
                                                                                          children: OptionGroup$ReactHooksTemplate.optionLabel([
                                                                                                x,
                                                                                                label
                                                                                              ]),
                                                                                          className: selected ? "text-left bg-ghostwhiteblue px-2 py-1 text-sm" : "hover:bg-gray-300 text-left px-2 py-1 text-sm",
                                                                                          onClick: (function (param) {
                                                                                              handleOptionClick({
                                                                                                    TAG: "DataFields",
                                                                                                    _0: {
                                                                                                      hd: [
                                                                                                        x,
                                                                                                        label
                                                                                                      ],
                                                                                                      tl: /* [] */0
                                                                                                    }
                                                                                                  }, selected);
                                                                                            })
                                                                                        }),
                                                                                    className: "border-b border-bottom-gray-600"
                                                                                  });
                                                                      }), option._0))
                                                          ]
                                                        })
                                                  });
                                    case "RedirectionUrls" :
                                        return JsxRuntime.jsx("div", {
                                                    children: JsxRuntime.jsxs(JsxRuntime.Fragment, {
                                                          children: [
                                                            JsxRuntime.jsx("div", {
                                                                  children: OptionGroup$ReactHooksTemplate.groupName(option),
                                                                  className: "text-base font-medium text-darkcharcoal m-2 p-1"
                                                                }),
                                                            $$Array.of_list(List.map((function (param) {
                                                                        var label = param[1];
                                                                        var x = param[0];
                                                                        var selected;
                                                                        selected = selectedOption.TAG === "RedirectionUrls" ? List.exists((function (param) {
                                                                                  return Caml_obj.equal(RedirectionUrl$ReactHooksTemplate.id(param[0]), RedirectionUrl$ReactHooksTemplate.id(x));
                                                                                }), selectedOption._0) : false;
                                                                        return JsxRuntime.jsx("div", {
                                                                                    children: JsxRuntime.jsx("div", {
                                                                                          children: OptionGroup$ReactHooksTemplate.optionLabel([
                                                                                                x,
                                                                                                label
                                                                                              ]),
                                                                                          className: selected ? "text-left bg-ghostwhiteblue px-2 py-1 text-sm" : "hover:bg-gray-300 text-left px-2 py-1 text-sm",
                                                                                          onClick: (function (param) {
                                                                                              handleOptionClick({
                                                                                                    TAG: "RedirectionUrls",
                                                                                                    _0: {
                                                                                                      hd: [
                                                                                                        x,
                                                                                                        label
                                                                                                      ],
                                                                                                      tl: /* [] */0
                                                                                                    }
                                                                                                  }, selected);
                                                                                            })
                                                                                        }),
                                                                                    className: "border-b border-bottom-gray-600"
                                                                                  });
                                                                      }), option._0))
                                                          ]
                                                        })
                                                  });
                                    case "TicketCategories" :
                                        return JsxRuntime.jsx("div", {
                                                    children: JsxRuntime.jsxs(JsxRuntime.Fragment, {
                                                          children: [
                                                            JsxRuntime.jsx("div", {
                                                                  children: OptionGroup$ReactHooksTemplate.groupName(option),
                                                                  className: "text-base font-medium text-darkcharcoal m-2 p-1"
                                                                }),
                                                            $$Array.of_list(List.map((function (param) {
                                                                        var label = param[1];
                                                                        var x = param[0];
                                                                        var selected;
                                                                        selected = selectedOption.TAG === "TicketCategories" ? List.exists((function (param) {
                                                                                  return Caml_obj.equal(TicketCategory$ReactHooksTemplate.id(param[0]), TicketCategory$ReactHooksTemplate.id(x));
                                                                                }), selectedOption._0) : false;
                                                                        return JsxRuntime.jsx("div", {
                                                                                    children: JsxRuntime.jsx("div", {
                                                                                          children: OptionGroup$ReactHooksTemplate.optionLabel([
                                                                                                x,
                                                                                                label
                                                                                              ]),
                                                                                          className: selected ? "text-left bg-ghostwhiteblue px-2 py-1 text-sm" : "hover:bg-gray-300 text-left px-2 py-1 text-sm",
                                                                                          onClick: (function (param) {
                                                                                              handleOptionClick({
                                                                                                    TAG: "TicketCategories",
                                                                                                    _0: {
                                                                                                      hd: [
                                                                                                        x,
                                                                                                        label
                                                                                                      ],
                                                                                                      tl: /* [] */0
                                                                                                    }
                                                                                                  }, selected);
                                                                                            })
                                                                                        }),
                                                                                    className: "border-b border-bottom-gray-600"
                                                                                  });
                                                                      }), option._0))
                                                          ]
                                                        })
                                                  });
                                    
                                  }
                                }), props.options)),
                      className: "flex flex-col border z-50 bg-white cursor-pointer rounded overflow-y-auto " + listBoxCSS,
                      style: {
                        maxHeight: "40vh",
                        position: "absolute",
                        width: "100%"
                      }
                    })
              ],
              ref: Caml_option.some(domElement),
              className: "relative w-full"
            });
}

var make = FilteredSelectBox;

exports.make = make;
/* react Not a pure module */
